declare global {
    interface Window {
        aiaibot?: {
            onReady: (callback: () => void) => void;
            onMessage: (callback: (payload: { id: string; type: string }) => void) => void;
            sendUserInput: (id: string, message: string) => void;
        };
    }
}

let pendingMessage = '';

function initAiaibotRelay(): void {
    if (!window.aiaibot) return;

    window.aiaibot.onReady(() => {
        window.aiaibot?.onMessage((payload) => {
            if (pendingMessage === '') return;
            // 'user-input' matches the aiaibot webchat's free-text widget; if the bot's story
            // is reconfigured to use a 'button-group' widget instead, this type must change too.
            if (payload.type !== 'user-input') return;
            window.aiaibot?.sendUserInput(payload.id, pendingMessage);
            pendingMessage = '';
        });
    });
}

function askAiaibot(message: string): void {
    const trimmed = message.trim();
    if (trimmed === '' || !window.aiaibot) return;

    pendingMessage = trimmed;
    // Triggers the aiaibot webchat: https://help.aiaibot.com/chatbot/stories-and-story-builder/trigger
    document.dispatchEvent(new CustomEvent('question'));
}

function initSearchInputs(): void {
    document.querySelectorAll<HTMLElement>('.search-input').forEach((wrapper) => {
        const input = wrapper.querySelector<HTMLInputElement>('.search-input__field');
        const submit = wrapper.querySelector<HTMLButtonElement>('.search-input__submit');
        if (!input) return;

        const submitSearch = (): void => askAiaibot(input.value);

        input.addEventListener('keydown', (event) => {
            if (event.key !== 'Enter' || event.shiftKey) return;
            event.preventDefault();
            submitSearch();
        });

        submit?.addEventListener('click', submitSearch);
    });
}

function initSearchToggle(): void {
    const trigger = document.querySelector<HTMLElement>('.site-header__search');
    const panelId = trigger?.getAttribute('aria-controls');
    const panel = panelId ? document.getElementById(panelId) : null;
    if (!trigger || !panel) return;

    const open = (): void => {
        panel.classList.add('is-open');
        panel.setAttribute('aria-hidden', 'false');
        trigger.setAttribute('aria-expanded', 'true');
        panel.querySelector<HTMLInputElement>('.search-input__field')?.focus();
    };

    const close = (): void => {
        panel.classList.remove('is-open');
        panel.setAttribute('aria-hidden', 'true');
        trigger.setAttribute('aria-expanded', 'false');
    };

    trigger.addEventListener('click', () => {
        if (panel.classList.contains('is-open')) {
            close();
        } else {
            open();
        }
    });

    document.addEventListener('click', (event) => {
        const target = event.target as Node;
        if (trigger.contains(target) || panel.contains(target)) return;
        close();
    });

    document.addEventListener('keydown', (event: KeyboardEvent) => {
        if (event.key !== 'Escape' || !panel.classList.contains('is-open')) return;
        close();
        trigger.focus();
    });
}

export function initSearch(): void {
    initAiaibotRelay();
    initSearchInputs();
    initSearchToggle();
}
